import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, Link } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from './Firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [resetMode, setResetMode] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      if (!userCredential.user.emailVerified) {
        throw new Error('Proszę zweryfikować email przed zalogowaniem.');
      }
      const redirect = searchParams.get('redirect');
      navigate(redirect || '/');
    } catch (err) {
      let errorMessage = 'Błąd logowania. Sprawdź email i hasło.';
      switch (err.code) {
        case 'auth/user-not-found':
        case 'auth/wrong-password':
          errorMessage = 'Nieprawidłowy email lub hasło.';
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Za dużo prób. Spróbuj później.';
          break;
        case 'auth/email-not-verified':
          errorMessage = 'Proszę zweryfikować email przed zalogowaniem.';
          break;
        case 'auth/invalid-credential':
          errorMessage = 'Nieprawidłowy e-mail lub hasło';
          break;
        default:
          errorMessage = `Błąd: ${err.message}`;
      }
      setError(errorMessage);
      console.error('Błąd logowania:', err);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setError('Proszę wpisać email, aby zresetować hasło.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setError('Link do resetu hasła został wysłany na Twój email.');
      setResetMode(false);
    } catch (err) {
      setError(`Błąd resetu hasła: ${err.message}`);
      console.error('Błąd resetu hasła:', err);
    }
  };

  const handleBackToLogin = () => {
    setResetMode(false);
    setError(null);
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 5, p: 2 }}>
      <Typography variant="h5" gutterBottom>{resetMode ? 'Reset hasła' : 'Logowanie'}</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {!resetMode ? (
        <form onSubmit={handleLogin}>
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            type="email"
            required
          />
          <TextField
            label="Hasło"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            type="password"
            required
          />
          <Button type="submit" variant="contained" sx={{ mt: 2 }}>
            Zaloguj się
          </Button>
          <Box sx={{ mt: 1 }}>
            <Link href="#" onClick={() => setResetMode(true)} variant="body2">
              Zapomniałeś hasła?
            </Link>
          </Box>
        </form>
      ) : (
        <Box>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Wprowadź swój email, aby otrzymać link do resetu hasła.
          </Typography>
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            type="email"
            required
          />
          <Button variant="contained" sx={{ mt: 2 }} onClick={handlePasswordReset}>
            Wyślij link resetujący
          </Button>
          <Box sx={{ mt: 1 }}>
            <Link href="#" onClick={handleBackToLogin} variant="body2">
              Powrót do logowania
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Login;
